import SuspendedProductPage from './suspended-product.container';

export default SuspendedProductPage;